module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo11-76c39b4577ef7cc024e654d4aa095174.jpg";